<template>
  <div :class="['c-tabMenu', createThumbnailBy === 'url' ? '--l' : '--r']">
    <div class="c-tabMenu-wrapper">
      <TabMenuText :className="['c-tabMenu__text', createThumbnailBy === 'url' ? '--selected' : '']" text="URLから作る"></TabMenuText>
      <TabMenuText :className="['c-tabMenu__text', createThumbnailBy === 'img' ? '--selected' : '']" text="画像から作る"></TabMenuText>
    </div>
  </div>
</template>

<script>
import TabMenuText from '@/components/atoms/TabMenuText.vue'

export default {
  components: {
    TabMenuText
  },
  props: {
    createThumbnailBy: String
  }
}

</script>

<style lang="scss" scoped>
.c-tabMenu {
  width: 600/1280*100vw;
  height: 60px;
  margin: 0 auto;
  background: $color_white;
  border-radius: 50px;
  box-shadow: $bs-default;
  position: relative;
  @include media-queries-sp {
    width: 100%;
  }

  &::before{
    content: "";
    width: calc(50% - 5px);
    height: 50px;
    border-radius: 50px;
    box-shadow: $bs-default;
    background: $color_blue_light;
    transition-duration: .3s;
    position: absolute;
    top: 5px;
  }
  &.--l {
    &::before {
      left: 5px;
      right: auto;
    }
  }
  &.--r {
    &::before {
      left: 50%
    }
  }

  &-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
  }

  &__text {
    color: $color_gray;
    font-size: 1.8rem;
    transition-duration: .3s;
    &:hover {
      color: $color_blue_dark;
      cursor: pointer;
    }
    &.--selected {
      @extend .c-tabMenu__text;
      color: #fff;
      font-weight: 700;
    }
  }
}
</style>
